import WrapperPaperTag from "./WrapperPaperTag";

export default WrapperPaperTag;
